import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const productApi = createApi({
  reducerPath: "productApi", // path to the reducer
  baseQuery: fetchBaseQuery({
    baseUrl: "https://my-app-ruwaf.ondigitalocean.app/api/v1/posts",
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = getState().auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }), // base query to fetch data
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ limit = 10, page = 1, filters = "" }) =>
        `?limit=${limit}&page=${page}${filters}`,
    }),
    getProduct: builder.query({
      query: ({ id }) => `/${id}`,
    }),
    getMyProducts: builder.query({
      query: () => ({
        url: "myposts/list",
        method: "GET",
        headers: (headers, { getState }) => {
          const token = getState().auth.token;
          if (token) {
            headers.set("Authorization", `Bearer ${token}`);
          }
          return headers;
        },
      }),
    }),
  }),
});

export const {
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useGetProductQuery,
  useAddProductMutation,
  useGetMyProductsQuery,
} = productApi;
